import React from 'react';

type TranscriptViewer = {
  transcript: string;
};

const format = (transcript: string) => {
  const lines = transcript.split('\n');
  return lines.map((x: string, i: number) => <div key={`t${i}`}>{x}</div>);
};

export default function TranscriptViewer({ transcript }: TranscriptViewer) {
  return <div className="viewer-mono">{format(transcript)}</div>;
}
